var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1732726048073,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10751,
    width: 48,
    height: 48,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M921.472 108.48c-19.904-21.44-51.2-29.504-81.088-32.384-31.36-3.008-68.992-1.024-109.44 4.288-81.152 10.624-179.2 35.264-273.472 65.6-94.272 30.336-186.176 66.88-254.976 101.824-34.24 17.408-64 35.072-85.568 51.968a156.928 156.928 0 0 0-27.904 27.136c-7.04 9.216-14.464 22.4-14.336 38.144 0.256 41.472 28.48 70.784 58.56 90.432 30.72 20.096 70.72 35.2 110.464 47.104 40.128 11.968 82.432 21.248 118.72 28.8l12.992 2.688c21.952 4.48 32.896 6.784 43.264 3.712 10.24-3.136 18.24-11.072 34.112-26.88l157.056-157.056a42.688 42.688 0 0 1 60.288 60.288L523.712 560.64c-16.192 16.192-24.32 24.256-27.328 34.752-3.072 10.496-0.64 21.632 4.352 43.904 19.136 86.4 35.776 157.76 52.352 205.824 9.6 28.032 20.544 52.352 34.368 70.208 14.336 18.688 33.92 32.832 59.712 33.92 16 0.768 29.44-6.592 38.528-13.376 9.664-7.168 18.752-16.768 27.136-27.264 16.896-21.12 34.624-50.304 52.288-84.096 35.52-67.84 73.088-158.784 104.96-252.352 31.744-93.568 58.24-191.104 71.04-272.192 6.336-40.448 9.472-78.016 7.68-109.44-1.6-29.888-7.936-61.184-27.328-82.048z",
    fill: "#333333",
    "p-id": 10752
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d81bb068e316a172deb20da69f30b632.svg";
export { ForwardRef as ReactComponent };